import { useDispatch } from 'react-redux'
import { InviteGuestDrawer as Drawer } from 'ui-components'
import {
  closeInviteGuestDrawer,
  useIsInviteGuestDrawerOpen
} from '~map-preview/states/ui'
import { InviteEmailInput } from './InviteEmailInput'
import { UninvitedGuestsList } from './UninvitedGuestsList'
import { UsersSearchList } from './UsersSearchList'

export const InviteGuestDrawer = () => {
  const dispatch = useDispatch()
  const open = useIsInviteGuestDrawerOpen()

  const handleClose = () => {
    dispatch(closeInviteGuestDrawer())
  }

  return (
    <Drawer
      open={open}
      onClose={handleClose}
      slots={{
        InviteEmailInput: <InviteEmailInput />,
        UninvitedGuestsList: <UninvitedGuestsList />,
        UsersSearchList: <UsersSearchList />
      }}
    />
  )
}
